import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FadeInSection } from '@/components/ui/FadeInSection';
import { OptimizedImage } from '@/components/ui/OptimizedImage';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function WikiAgriTechSection() {
  const { t } = useTranslation('home');
  return (
    <section className="py-12 bg-aspexit-gray-light">
      <div className="container mx-auto px-4 max-w-7xl">
        <FadeInSection>
          <div className="max-w-3xl mx-auto">
          <Card className="relative overflow-hidden border-2 border-border hover:shadow-xl transition-shadow">
            {/* Barre verticale verte sur le côté gauche */}
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-aspexit-green" />

            {/* Contenu */}
            <div className="p-6 md:p-8 text-center">
              {/* Logo WAT SVG officiel */}
              <div className="mx-auto mb-4 flex justify-center">
                <svg viewBox="0 0 300 100" className="h-16" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Wiki Agri Tech - Agriculture et Numérique">
                  <text x="10" y="40" fill="#0066CC" fontSize="32" fontWeight="bold" fontFamily="Arial, sans-serif">WIKI</text>
                  <text x="10" y="72" fill="#0066CC" fontSize="32" fontWeight="bold" fontFamily="Arial, sans-serif">AGRI TECH</text>
                  <text x="10" y="90" fill="#0066CC" fontSize="11" fontWeight="normal" fontFamily="Arial, sans-serif" letterSpacing="2">AGRICULTURE & NUMÉRIQUE</text>
                </svg>
              </div>

              {/* Badge */}
              <div className="inline-block px-3 py-1 bg-aspexit-green/10 text-aspexit-green text-xs font-medium rounded-full mb-3">
                {t('wikiAgriTech.badge')}
              </div>

              {/* Titre */}
              <h2 className="text-3xl md:text-4xl font-heading font-extrabold mb-3 text-aspexit-black">
                {t('wikiAgriTech.title')}
              </h2>

              {/* Description */}
              <p className="text-base text-aspexit-gray mb-6 max-w-2xl mx-auto">
                {t('wikiAgriTech.description')}
              </p>

              {/* Image isométrique */}
              <div className="mb-6 flex justify-center">
                <OptimizedImage
                  src="/wat-isometric-farm.png"
                  alt="Illustration isométrique d'une exploitation agricole numérique"
                  fallbackSrc="/wat-isometric-farm.png"
                  className="w-full max-w-xs h-auto rounded-lg"
                  loading="lazy"
                />
              </div>

              {/* Statistiques */}
              <div className="grid grid-cols-3 gap-4 mb-6 max-w-lg mx-auto">
                <div>
                  <div className="text-2xl font-bold text-aspexit-green mb-1">
                    2500+
                  </div>
                  <div className="text-xs text-aspexit-gray">{t('wikiAgriTech.stats.tools')}</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-aspexit-green mb-1">
                    1300+
                  </div>
                  <div className="text-xs text-aspexit-gray">{t('wikiAgriTech.stats.companies')}</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-aspexit-green mb-1">
                    60+
                  </div>
                  <div className="text-xs text-aspexit-gray">{t('wikiAgriTech.stats.articles')}</div>
                </div>
              </div>

              {/* CTA centré */}
              <Button
                asChild
                size="lg"
                className="bg-aspexit-green hover:bg-aspexit-green-dark transition-colors"
              >
                <a
                  href="https://www.wiki-agri-tech.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  {t('wikiAgriTech.cta')}
                  <ExternalLink className="w-4 h-4" />
                </a>
              </Button>
            </div>
          </Card>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
